module.exports = __webpack_public_path__ + "img/44-zjjtzy.829670c2.png";